import { render, staticRenderFns } from "./NodeDetail.vue?vue&type=template&id=3552069a&scoped=true"
import script from "./NodeDetail.vue?vue&type=script&lang=js"
export * from "./NodeDetail.vue?vue&type=script&lang=js"
import style0 from "./NodeDetail.vue?vue&type=style&index=0&id=3552069a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552069a",
  null
  
)

export default component.exports